import { ar } from "./ar";
import { en } from "./en";

const localization = {
  en,
  ar,
};

export default localization;
